import type { Currency } from "@/types";

export const currenciesMap: Map<string, Currency> = new Map([
    ["USD", { code: "USD", name: "United States Dollar", symbol: "$" }],
    ["EUR", { code: "EUR", name: "Euro", symbol: "€" }],
    ["UAH", { code: "UAH", name: "Ukrainian Hryvnia", symbol: "₴" }],
    ["GBP", { code: "GBP", name: "British Pound", symbol: "£" }],
]);